// src/pages/Home.jsx
import { Link } from 'react-router-dom';
import './styles/main.css';
import { FaHeartbeat, FaBabyCarriage, FaHandHoldingHeart } from 'react-icons/fa';

export default function Home() {
  return (
    <div className="home-page">
            <section className="hero-about bg-dark text-white py-8">
        <div className="container text-center">
        <div className="row min-vh-80 align-items-center py-8">
            <div className="col-12 text-center text-white">
              <h1 className="display-6 fw-bold mb-4 text-uppercase">
                <span className="text-gradient-primary">Homeward Bound</span> Midwifery
              </h1>
              <p className="lead fs-2 mb-5">Compassionate Care for Every Stage of Motherhood</p>
              <div className="d-flex gap-3 justify-content-center">
                <Link to="/care-packages" className="btn btn-light btn-lg px-5 py-3 rounded-pill">
                  Explore Services <i className="ms-2 bi bi-arrow-right"></i>
                </Link>
                <Link to="/schedule-consultation" className="btn btn-outline-light btn-lg px-5 py-3 rounded-pill">
                  Schedule Consultation
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* Features Section */}
      <section className="py-7 bg-light">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-4 mt-2 mb-2">
              <div className="card h-100 border-0 shadow-lg hover-effect">
                <div className="card-body p-5 text-center">
                  <FaHeartbeat className="display-4 text-gradient-primary mb-4 red-text" />
                  <h3 className="h2 mb-3">Preconception Care</h3>
                  <p className="text-muted mb-4">Optimize your health with personalized planning and expert guidance</p>
                  <Link to="/preconception-care" className="btn btn-link text-decoration-none red-text">
                    Learn More <i className="bi bi-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-4 mt-2 mb-2">
              <div className="card h-100 border-0 shadow-lg hover-effect">
                <div className="card-body p-5 text-center">
                  <FaBabyCarriage className="display-4 text-gradient-primary mb-4 blue-text" />
                  <h3 className="h2 mb-3">Pregnancy Care</h3>
                  <p className="text-muted mb-4">Holistic support through every trimester and beyond</p>
                  <Link to="/antenatal-care" className="btn btn-link text-decoration-none blue-text">
                    Learn More <i className="bi bi-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-4 mt-2 mb-2">
              <div className="card h-100 border-0 shadow-lg hover-effect">
                <div className="card-body p-5 text-center">
                  <FaHandHoldingHeart className="display-4 text-gradient-primary mb-4 green-text" />
                  <h3 className="h2 mb-3">Postnatal Care</h3>
                  <p className="text-muted mb-4">Comprehensive recovery support for new mothers</p>
                  <Link to="/postnatal-care" className="btn btn-link text-decoration-none green-text">
                    Learn More <i className="bi bi-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-7 bg-white">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 mt-2 mb-2">
            <img 
                src="https://images.pexels.com/photos/4473878/pexels-photo-4473878.jpeg" 
                alt="Midwife care"
                className="img-fluid rounded-4 shadow-lg"
                style={{maxHeight: "500px", objectFit: "cover"}}
              />
            </div>
            <div className="col-lg-6 mt-2 mb-2">
              <h2 className="display-5 fw-bold mb-4">Why Choose Our Midwifery Services?</h2>
              <div className="d-flex mb-4">
                <div className="me-4 text-primary">
                  <i className="bi bi-check2-circle fs-2"></i>
                </div>
                <div>
                  <h3 className="h4">Personalized Care Plans</h3>
                  <p className="text-muted">Tailored support for your unique pregnancy journey</p>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="me-4 text-primary">
                  <i className="bi bi-people fs-2"></i>
                </div>
                <div>
                  <h3 className="h4">Experienced Practitioners</h3>
                  <p className="text-muted">Certified midwives with 10+ years average experience</p>
                </div>
              </div>
              <div className="d-flex">
                <div className="me-4 text-primary">
                  <i className="bi bi-house-heart fs-2"></i>
                </div>
                <div>
                  <h3 className="h4">Home & Clinic Options</h3>
                  <p className="text-muted">Flexible care in your preferred environment</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-7 bg-primary text-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h2 className="display-5 text-white mb-4">Start Your Journey with Confidence</h2>
              <p className="lead text-white mb-5">Book your free initial consultation today</p>
              <Link to="/contact" className="btn btn-light btn-lg px-6 py-3 rounded-pill">
                Get Started Now <i className="ms-2 bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}